import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DatePipe, NgComponentOutlet } from '@angular/common';
import { AuthService } from '@brightside/core/auth';
import { DashboardWidgetRegistryService } from '../registry/dashboard-widget-registry.service';

function dayPart(now: Date): 'morning' | 'afternoon' | 'evening' {
  const hour = now.getHours();
  if (hour < 12) {
    return 'morning';
  }
  if (hour < 17) {
    return 'afternoon';
  }
  return 'evening';
}

function givenName(displayName: string): string {
  const first = displayName.trim().split(/\s+/)[0];
  return first ?? '';
}

/**
 * BrightNav Home host. Greeting is page chrome; feature views come from
 * {@link DashboardWidgetRegistryService} so this page does not import those libs.
 */
@Component({
  selector: 'bn-dashboard-page',
  standalone: true,
  imports: [DatePipe, NgComponentOutlet],
  templateUrl: './dashboard-page.component.html',
  styleUrl: './dashboard-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardPageComponent {
  private readonly _auth = inject(AuthService);
  protected readonly registry = inject(DashboardWidgetRegistryService);
  protected readonly today = new Date();

  protected greeting(): string {
    const name = givenName(this._auth.userDisplayName());
    const hello = `Good ${dayPart(this.today)}`;
    return name ? `${hello}, ${name}` : hello;
  }
}
